import { requestFiles } from 'shared/api/services/file-storage';
import type { Directory, IFile } from 'shared/types/file-storage-types';

export async function fetchFiles(
  directory: Directory,
  folderPath: string,
  slug: string
): Promise<IFile[]> {
  const res = await requestFiles(directory, folderPath, slug);

  if (!res.ok) {
    if (res.status === 500 || res.status === 404) {
      return [];
    }
    throw new Error(`${res.status}`);
  }
  return await res.json();
}
